import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_AcknowledgementGrievanceProcedures = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_AcknowledgementGrievanceProcedures' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Acknowlegment of Grievance Procedures</h3></p>

                <p className='w-750'>
                    I have been informed of the policies and procedures for reporting a grievance concerning 
                    any treatment or service that i receive.
                </p>


            </div>
        </form >

    )
}











